<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter" v-if="isIndex()">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row">
              <div class="col-md-auto">
                <label for>{{ $t('devices.station') }}:</label>
                <el-select
                  id="listStations"
                  clearable
                  filterable
                  class="select-primary custom-width-select mb-3 shadow-sm required-station"
                  v-model="model.station"
                  :placeholder="`${$t('common_words.select2')}...`"
                  @change="getSensors(), changeByInterval()"
                >
                  <el-option
                    class="select-primary"
                    v-for="(station, index) in listStations"
                    :key="index"
                    :label="station.name"
                    :value="station.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-3 text-left">
                <label for>{{ $t('devices.sensors') }}:</label>
                <el-select
                  id="listSensors"
                  clearable
                  v-bind:collapse-tags="true"
                  multiple
                  class="select-primary custom-width-select mb-3 shadow-sm required-sensors"
                  filterable
                  v-model="model.sensors"
                  :placeholder="$t('devices.select_sensors')"
                  @change="
                    selectAllFromSelect('model.sensors', listSensors),
                      changeByInterval()
                  "
                >
                  <el-option
                    v-for="(sensor, index) in listSensors"
                    class="select-primary selected-all"
                    :value="sensor.id"
                    :label="sensor.name"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-3 text-left">
                <label for>{{ $t('devices.calculated_variable') }}:</label>
                <el-select
                  id="listSensors"
                  clearable
                  v-bind:collapse-tags="true"
                  multiple
                  class="select-primary custom-width-select mb-3 shadow-sm required-sensors2"
                  filterable
                  v-model="model.sensors2"
                  :placeholder="$t('devices.select_calculated_variable')"
                  @change="
                    selectAllFromSelect('model.sensors2', listSensors2),
                      changeByInterval()
                  "
                >
                  <el-option
                    v-for="(sensor, index) in listSensors2"
                    class="select-primary selected-all"
                    :value="sensor.id"
                    :label="sensor.name"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto">
                <label for>{{ $t('devices.default_grouping') }}:</label>
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 shadow-sm required-defaultGrouping"
                  :placeholder="`${$t('common_words.select2')}...`"
                  v-model="model.defaultGrouping"
                  @change="
                    model.defaultGrouping == 0
                      ? (model.inBars = 0)
                      : (model.inBars = 0),
                      changeByInterval()
                  "
                >
                  <el-option
                    class="select-primary"
                    v-for="(option, index) in listDefaultGrouping"
                    :key="index"
                    :label="option.name"
                    :value="option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto" v-if="model.defaultGrouping == 0">
                <label for>{{ $t('devices.in_bars') }}:</label>
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 shadow-sm required-defaultGrouping"
                  :placeholder="`${$t('common_words.select2')}...`"
                  v-model="model.inBars"
                  @change="changeByInterval()"
                >
                  <el-option
                    class="select-primary"
                    v-for="(option, index) in listInBars"
                    :key="index"
                    :label="option.name"
                    :value="option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto">
                <label>{{ $t('common_words.analyze_by') }}</label>
                <br />
                <el-select
                  @change="changeByInterval()"
                  filterable
                  @clear="model.bySel = null"
                  class="select-primary custom-width-select mb-3 required-year shadow-sm"
                  size="large"
                  v-model="model.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in Object.values(optionsInterval)"
                    class="select-primary"
                    :value="option.id"
                    :label="option.label"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-md-auto"
                v-if="model.bySel != '2' && model.bySel != '4'"
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  v-model="model.rangeDate"
                  ref="dateRangePicker"
                  class="shadow-sm mb-3 required-dateRange"
                  v-bind:type="typedatepicket"
                  range-separator="-"
                  :clearable="false"
                  :picker-options="pickerOptions"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                  @change="changeByInterval()"
                ></el-date-picker>
              </div>
              <div class="col-md-auto mb-3" v-if="model.bySel == '0'">
                <label>{{ $t('common_words.time') }}</label>
                <el-time-picker
                  is-range
                  v-model="model.rangeHour"
                  format="HH:mm:ss"
                  value-format="HH:mm:ss"
                  placeholder="Formato hh:mm:ss 24 Horas"
                  :clearable="false"
                />
              </div>
              <div
                class="col-md-auto"
                v-if="model.bySel == '2' || model.bySel == '4'"
              >
                <label>{{ $t('common_words.initial_year') }}:</label>
                <br />
                <el-select
                  id="year_sel_init"
                  filterable
                  class="select-primary custom-width-select mb-3 required-year shadow-sm"
                  size="large"
                  v-model="model.year_sel_init"
                  @change="changeByInterval()"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(listYears).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto" v-if="model.bySel == '2'">
                <label>{{ $t('common_words.initial_week') }}:</label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 required-week shadow-sm"
                  size="large"
                  v-model="model.week_sel_init"
                  @change="changeByInterval()"
                >
                  <el-option
                    v-for="(week, index) in listYears[model.year_sel_init]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-md-auto"
                v-if="model.bySel == '2' || model.bySel == '4'"
              >
                <label>{{ $t('common_words.end_year') }}:</label>
                <br />
                <el-select
                  id="year_sel_end"
                  filterable
                  class="select-primary custom-width-select mb-3 required-year shadow-sm"
                  size="large"
                  v-model="model.year_sel_end"
                  @change="changeByInterval()"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(listYears).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto" v-if="model.bySel == '2'">
                <label>{{ $t('common_words.end_week2') }}:</label>
                <br />
                <el-select
                  filterable
                  class="select-primary custom-width-select mb-3 required-week shadow-sm"
                  size="large"
                  v-model="model.week_sel_end"
                  @change="changeByInterval()"
                >
                  <el-option
                    v-for="(week, index) in listYears[model.year_sel_end]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-md-auto">
                <label class="label-primary" style="color: transparent">
                  {{ $t('common_words.filter') }}
                </label>
                <br />
                <l-button
                  wide
                  type="info"
                  class="btn-filter mb-3"
                  @click="validate"
                  >{{ $t('common_words.filter') }}</l-button
                >
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <br />
        <div v-if="isIndex()">
          <div v-if="showReport">
            <div v-for="(data, index) in highChartsData" :key="index">
              <card class="custom-shadow-card-header">
                <div class="row">
                  <div class="col-12">
                    <high-charts :highChartsData="data"></high-charts>
                  </div>
                </div>
              </card>
            </div>
            <hr />
            <card-header
              :propPagination="pagination"
              @searchedQuery="searchedQuery"
              class="mr-3 mt-3"
            ></card-header>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'period', order: 'descending' }"
                :data="queriedData"
                style="width: 100%"
                :border="true"
                max-height="550"
              >
                <el-table-column
                  v-for="(column, index) in tableColumns"
                  :key="index"
                  :prop="column.prop"
                  :label="column.label"
                  :align="column.align"
                  :sortable="column.sortable"
                  :min-width="column.minWidth"
                  :fixed="column.fixed"
                  :resizable="false"
                >
                  <template v-if="column.data">
                    <el-table-column
                      v-for="(column2, index) in column.data"
                      :key="index"
                      :prop="column2.prop"
                      :label="column2.label"
                      :align="column2.align"
                      :sortable="column2.sortable"
                      :min-width="column2.minWidth"
                      :fixed="column2.fixed"
                      :resizable="false"
                    >
                      <template slot-scope="props">
                        <div v-if="props.row[column2.prop]">
                          {{ props.row[column2.prop] }}
                        </div>
                        <div v-else>{{ '0.00' }}</div>
                      </template>
                    </el-table-column>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="my-3 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  {{ $t('table2.showing') }} {{ from + 1 }}
                  {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                  {{ total }} {{ $t('table2.entries') }}
                </p>
              </div>
              <l-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                pageFirst="false"
                pageLast="false"
              ></l-pagination>
            </div>
            <export-tables
              :pdf="{
                filename: `${$t('common_words.weather_station_report')}.pdf`,
                route: 'climates/weatherstationreport/pdf',
                paramMethod: 'POST',
                plusData: {
                  tableColumns: tableColumns,
                  tableData: tableData,
                },
              }"
              :xls="{
                filename: `${$t('common_words.weather_station_report')}.xlsx`,
                route: 'climates/weatherstationreport/excel',
                paramMethod: 'POST',
                plusData: {
                  tableColumns: tableColumns,
                  tableData: tableData,
                },
              }"
            />
          </div>
        </div>
      </card>
      <div v-else>
        <br />
        <h5 class="text-muted text-center">
          {{ $t('common_words.no_permissions') }}
        </h5>
      </div>
    </div>
  </div>
</template>
<script>
import { Pagination as LPagination } from 'src/components/index';
import Tables from 'src/class/Tables';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinDatePicker from 'src/util/mixinDatePicker';
import Fuse from 'fuse.js';
import { Axios } from 'src/class/Axios.js';
import axios from 'axios';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';
import paginationData from './paginationData';

import highCharts from './highCharts/highCharts.vue';

export default {
  components: {
    LPagination,
    highCharts,
  },
  computed: {
    ...Tables.search,
    ...paginationData.functions,
  },
  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinMenu,
    MixinDatePicker,
    MixinForm,
  ],
  data() {
    return {
      model: {
        station: null,
        sensors: [],
        sensors2: [],
        defaultGrouping: 1,
        inBars: 0,
        bySel: 2,
        year_sel_init: null,
        week_sel_init: 1,
        year_sel_end: null,
        week_sel_end: 1,
        rangeDate: [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
        ],
        rangeHour: ['00:00:00', '23:59:59'],
      },

      highChartsData: [],
      highChartsType: '',

      tableData: [],
      tableColumns: [],
      listStations: [],
      listSensors: [],
      listSensors2: [],
      listYears: [],
      listDefaultGrouping: [
        { id: 1, name: 'Si' },
        { id: 0, name: 'No' },
      ],
      listInBars: [
        { id: 1, name: 'Si' },
        { id: 0, name: 'No' },
      ],
      renderComponent: true,
      activeName: '1',
      showReport: false,
      pagination: paginationData.pagination,
      searchQuery: '',
      typedatepicket: 'daterange',
    };
  },
  watch: {
    '$i18n.locale': 'loadMap',
  },
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }
      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    optionsInterval() {
      return {
        0: {
          id: 0,
          label: this.$i18n.t('common_words.time'),
          value: 'daterange',
        },
        1: {
          id: 1,
          label: this.$i18n.t('common_words.day'),
          value: 'daterange',
        },
        2: { id: 2, label: this.$i18n.t('common_words.week'), value: 'week' },
        3: {
          id: 3,
          label: this.$i18n.t('common_words.month'),
          value: 'monthrange',
        },
        4: { id: 4, label: this.$i18n.t('common_words.year'), value: 'year' },
      };
    },
    getLabelInterval() {
      try {
        return Object.values(this.optionsInterval).find(
          (option) => option.value === this.model.bySel
        ).label;
      } catch (error) {
        return this.$i18n.t('common_words.interval');
      }
    },
  },
  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    changeByInterval() {
      this.showReport = false;
      this.tableData = [];
      this.tableColumns = [];
      this.typedatepicket = Object.values(this.optionsInterval).filter(
        (item) => item.id === this.model.bySel
      )[0].value;
    },
    getSensors() {
      this.model.sensors = [];
      this.model.sensors2 = [];
      axios
        .get(`/sensorsPerStation2/${this.model.station}/0`)
        .then((response) => {
          this.listSensors =
            response.data.length > 0 ? this.concatAll(response.data) : [];
          axios
            .get(`/sensorsPerStation2/${this.model.station}/1`)
            .then((response2) => {
              this.listSensors2 =
                response2.data.length > 0 ? this.concatAll(response2.data) : [];
            })
            .catch((error2) => {
              SweetAlert.warning('Error al cargar sensores');
            });
        })
        .catch((error) => {
          SweetAlert.warning('Error al cargar sensores');
        });
    },
    extractProps(columns) {
      let props = [];
      columns.forEach((col) => {
        if (col.prop) {
          props.push(col.prop);
        }
        if (col.data) {
          props = props.concat(this.extractProps(col.data));
        }
      });
      return props;
    },
    async validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (!this.model.station) {
          return this.validationInputsRequired('station');
        }
        if (this.model.sensors.length == 0) {
          return this.validationInputsRequired('sensors');
        }
        if (!this.model.rangeDate) {
          return this.validationInputsRequired('dateRange');
        }
        if (!this.model.year_sel_init) {
          return this.validationInputsRequired('year');
        }
        if (!this.model.year_sel_end) {
          return this.validationInputsRequired('year');
        }
        if (isValid) this.getData();
      });
    },
    getData() {
      this.showReport = false;
      this.showHideLoading(true);
      let param = {
        route: 'climates/weatherstationreport/getreportinfo',
        model: this.model,
      };
      Axios.postMasters(param)
        .then((response) => {
          let responseData = response.data.data;
          this.tableColumns = responseData.tableColumns;
          this.tableData = responseData.tableData;
          this.highChartsData = responseData.graphics;
          const keys = this.extractProps(this.tableColumns);
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: keys,
          });
          if (this.tableData.length == 0)
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          else this.showReport = true;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },
  },
  created() {
    this.showHideLoading(true);
    Axios.getMasters('devices/stations');
    axios
      .all([
        Axios.getMasters('devices/stations'),
        Axios.getMasters('climates/weatherstationreport/getselectinfo'),
      ])
      .then(
        axios.spread((response1, response2) => {
          this.listStations = response1.data.data;
          this.listYears = response2.data.listYears;
          this.model.year_sel_init = Object.keys(this.listYears).reverse()[0];
          this.model.year_sel_end = Object.keys(this.listYears).reverse()[0];
          this.showHideLoading();
        })
      )
      .catch((error) => {
        this.showHideLoading();
        SweetAlert.warning(error.response.data.message);
      });
  },
  mounted() {
    this.selectedItemOnMenu('climates');
  },
  destroyed() {
    this.deselectedItemOnMenu('climates');
  },
};
</script>
